import { styled } from "@mui/material/styles";
import { StepButton, StepLabel } from "@mui/material";

export const StyledStepButton = styled(StepButton)({
  padding: 0,
  margin: 0,
  justifyContent: "flex-start",
});

export const StyledLabel = styled(StepLabel)(({ theme }) => ({
  [`& .MuiStepLabel-iconContainer`]: {
    alignSelf: "flex-start",
    margin: 0,
    paddingRight: theme.spacing(1.5),
  },
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
    minHeight: "160px",
  },
}));
